import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// Issue #503 — Inventory valuation GL bridge tracking.
//
// Adds side-effect state to inventory_stock_entries so submitted inventory
// movements can be reconciled without mutating append-only stock movement
// rows. The GL itself is still written through accounting public APIs.
// ============================================================================

export const migration: ModuleMigrationDef = {
  key: "003_valuation_gl_tracking",
  version: "1.2.0",
  sql: `
    ALTER TABLE \`inventory_stock_entries\` ADD COLUMN \`valuation_gl_status\` text NOT NULL DEFAULT 'pending';
    ALTER TABLE \`inventory_stock_entries\` ADD COLUMN \`valuation_gl_entry_ids\` text;
    ALTER TABLE \`inventory_stock_entries\` ADD COLUMN \`valuation_gl_reversal_of\` text;
    ALTER TABLE \`inventory_stock_entries\` ADD COLUMN \`valuation_gl_error\` text;
    ALTER TABLE \`inventory_stock_entries\` ADD COLUMN \`valuation_gl_non_financial_reason\` text;
    ALTER TABLE \`inventory_stock_entries\` ADD COLUMN \`valuation_gl_attempts\` integer NOT NULL DEFAULT 0;
    ALTER TABLE \`inventory_stock_entries\` ADD COLUMN \`valuation_gl_last_attempt_at\` text;
    ALTER TABLE \`inventory_stock_entries\` ADD COLUMN \`valuation_gl_posted_at\` text;

    UPDATE \`inventory_stock_entries\`
    SET
      \`valuation_gl_status\` = 'non_financial',
      \`valuation_gl_non_financial_reason\` = 'Zero valuation amount'
    WHERE COALESCE(\`valuation_amount\`, ABS(\`qty\` * \`rate\`), 0) <= 0;

    UPDATE \`inventory_stock_entries\`
    SET
      \`valuation_gl_status\` = 'external',
      \`valuation_gl_non_financial_reason\` = 'Valuation GL is handled by the accounting invoice COGS bridge'
    WHERE \`source\` IN ('sales_invoice', 'sales_invoice_cancelled', 'credit_note');

    UPDATE \`inventory_stock_entries\`
    SET
      \`valuation_gl_status\` = 'non_financial',
      \`valuation_gl_non_financial_reason\` = 'No automatic inventory valuation GL rule is configured for this source'
    WHERE COALESCE(\`valuation_amount\`, ABS(\`qty\` * \`rate\`), 0) > 0
      AND COALESCE(\`source\`, '') NOT IN (
        'goods_receipt',
        'goods_receipt_cancelled',
        'delivery_order',
        'delivery_order_cancelled',
        'sales_invoice',
        'sales_invoice_cancelled',
        'credit_note'
      );

    UPDATE \`inventory_stock_entries\`
    SET
      \`valuation_gl_status\` = 'pending',
      \`valuation_gl_non_financial_reason\` = NULL
    WHERE COALESCE(\`valuation_amount\`, ABS(\`qty\` * \`rate\`), 0) > 0
      AND \`source\` = 'manual'
      AND \`entry_type\` = 'adjustment';

    CREATE INDEX IF NOT EXISTS \`se_valuation_gl_status_idx\`
      ON \`inventory_stock_entries\` (\`company_id\`, \`valuation_gl_status\`, \`posting_date\`);
    CREATE INDEX IF NOT EXISTS \`se_valuation_gl_reversal_idx\`
      ON \`inventory_stock_entries\` (\`company_id\`, \`valuation_gl_reversal_of\`);
  `,
};
